import axios from "axios";

const LOGIN_ROUTE = '/rest/v4/login';
const LOGOUT_ROUTE = '/rest/v4/logout';

let uninterceptedAxiosInstance = axios.create();

export default {
    login(username, password) {
        return uninterceptedAxiosInstance.post(LOGIN_ROUTE, { username, password });
    },

    logout() {
        return axios.post(LOGOUT_ROUTE);
    }
}
